import { ActionField, CommentField, DocumentField, StatusField } from './Fields'
import {
  PercentageProgressTask,
  PlanPassFailTask,
  PlanInProgressDoneTask,
  PlanSubmitApproveRejectTask,
} from './components'

import { FunctionComponent } from 'react'
import { ITemplateProp } from '@/screens/Order/Pages/OrderOverview/TaskTemplate.interface'

interface TemplateType extends FunctionComponent<ITemplateProp> {}

export const TASK_TEMPLATE = {
  percentage_progress_type: PercentageProgressTask as TemplateType,
  plan_pass_fail_type: PlanPassFailTask as TemplateType,
  plan_inprogress_done_type: PlanInProgressDoneTask as TemplateType,
  plan_submit_approve_reject_type: PlanSubmitApproveRejectTask as TemplateType,
}

export const FIELD_TEMPLATE = {
  status: StatusField,
  comment: CommentField,
  document: DocumentField,
  action: ActionField,
}
